<template>
  <div class="left-box" :style="autoH?'height: auto;':''">
    <div class="left-title">
      <span style="cursor: pointer;" @click="titleClick">{{title}}</span>
      <template v-if="showAction.indexOf('Create') != -1">
        <el-button type="text" @click="create()" icon="el-icon-circle-plus-outline"></el-button>
      </template>
    </div>
    <div style="border-bottom: 1px solid #e4e7ed">
      <el-input class="search" clearable placeholder="输入名称" v-model="text">
        <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
      </el-input>
    </div>
    <div class="left-main m-scroll" style="height: calc(100% - 69px)">
      <el-tree
        ref="tree"
        :data="treeData"
        :node-key="treeKey"
        :default-expand-all="false"
        :props="defaultProps"
        :check-on-click-node="true"
        :expand-on-click-node="false"
        @node-click="onSelect"
        @node-contextmenu="openMenu"
        :filter-node-method="filterNode"
      >
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span class="label" :title="node.label" :class="{'current-node':node.isCurrent}">
            <span>{{data.PdaDeviceName}}</span>
          </span>
          <span class="node-btn" v-if="showAction.indexOf('Create') != -1">
            <el-button type="text" @click="create(data)" icon="el-icon-circle-plus-outline"></el-button>
          </span>
        </span>
      </el-tree>
    </div>
    <ul v-show="visible" :style="{left:menu.left+'px',top:menu.top+'px'}" class="contextmenu">
      <li v-if="showAction.indexOf('Edit') != -1" @click="edit(menu.selectedTag)">编辑</li>
      <li v-if="showAction.indexOf('Delete') != -1" @click="del(menu.selectedTag)">删除</li>
    </ul>
    <!-- <edit-dialog ref="editDialog" @close-saved="getData({ Pid: 0 })" /> -->
  </div>
</template>
<script>
// import editDialog from "./editDialog";

export default {
  components: { 
    // editDialog 
  },
  props: {
    treeKey: {
      type: String,
      default: "PdaDeviceId",
    },
    treeLabel: {
      type: String,
      default: "PdaDeviceName",
    },
    title: {
      type: String,
      default: "所有PDA设备",
    },
    delText: {
      type: String,
      default: "确定删除这个类别吗？",
    },
    showAction: {
      type: String,
      default: () => "Create|Edit|Delete",
    },
    parentClick: {
      type: Boolean,
      default: () => true,
    },
    autoH: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      api: require('@/api/ba/pdaDevice').default,
     
      treeData: [],
      defaultProps: {
        children: "children",
        label: this.treeLabel,
      },
      text: "",
      nowId: null,
      visible: false,
      menu: {
        top: 0,
        left: 0,
        selectedTag: {},
      },
    };
  },
  watch: {
    visible(value) {
      if (value) {
        document.body.addEventListener("click", this.closeMenu);
      } else {
        document.body.removeEventListener("click", this.closeMenu);
      }
    },
  },
  mounted() {
    // this.getData({});
  },
  methods: {
    titleClick() {
      //console.log("title-click");
      this.$emit("title-click");
      this.resetSelect();
    },
 
    getData(params = {}) {
   
      this.api.list({}).then((res) => {
 
        // this.treeData = this.$commonJs.toTreeData(res.Data, this.treeKey);
        this.treeData = res.Data
    
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(this.nowId);
        });
      });
    },
    // getData(params = {}) {
    //   params = { ...params, HasChild: true };
    //   this.api.list(params).then((res) => {
    //     // //console.log("tree_getData", res);
    //     // res.Data = res.Data.map((x) => {
    //     //   return { ...x, Pid: 0 };
    //     // });
    //     this.treeData = this.$commonJs.toTreeData(res.Data, this.treeKey);
    //     // //console.log("treeData", this.treeData, this.treeKey);
    //     this.$nextTick(() => {
    //       this.$refs.tree.setCurrentKey(this.nowId);
    //     });
    //   });
    // },
    search() {
      this.$refs.tree.filter(this.text);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.NameChain.indexOf(value) !== -1;
    },
    resetSelect() {
      this.setKey(null);
    },
    setKey(key) {
      this.$refs.tree.setCurrentKey(key);
    },
    create(data) {
      //console.log("create", data);
      let parent = {};
      if (data != undefined) {
        parent = { Pid: data[this.treeKey], Pname: data[this.treeLabel] };
      }
      this.$refs.editDialog.openCreate(parent);
    },
    edit(data) {
      this.$refs.editDialog.openEdit(data);
    },
    del(data) {
      //console.log(data);
      this.$confirm(this.delText, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.api.delete(data[this.treeKey]).then((res) => {
            //console.log(res);
            if (res.Code == 0) {
              this.$message.success(res.Msg);
              this.getData();
            } else {
              this.$message.error(res.Msg);
            }
          });
        })
        .catch(() => {});
    },
    openMenu(e, data) {
      var actions = this.showAction.split("|");
      if (!actions.find((x) => x == "Edit" || x == "Delete")) {
        return;
      }
      const menuMinWidth = 105;
      const offsetLeft = this.$el.getBoundingClientRect().left; // container margin left
      const offsetWidth = this.$el.offsetWidth; // container width
      const maxLeft = offsetWidth - menuMinWidth + 56; // left boundary
      const left = e.clientX - offsetLeft + 70; // 15: margin right

      if (left > maxLeft) {
        this.menu.left = maxLeft;
      } else {
        this.menu.left = left;
      }
      this.menu.top = e.clientY;
      this.visible = true;
      this.menu.selectedTag = data;
    },
    closeMenu() {
      this.visible = false;
    },
    onSelect(node, self) {
      if (this.parentClick) {
        this.nowId = node[this.treeKey];
        this.$emit("on-select", node);
      } else {
        if (node.children != undefined) {
          self.isCurrent = false;
        } else {
          this.nowId = node[this.treeKey];
          this.$emit("on-select", node);
        }
      }
    },
  },
};
</script>
<style lang="scss">
.search {
  .el-input__inner {
    border: none;
  }
  .el-input-group__append {
    border: none;
  }
}
</style>